import { render, staticRenderFns } from "./OverdueAlert.vue?vue&type=template&id=fb420480"
import script from "./OverdueAlert.vue?vue&type=script&lang=js"
export * from "./OverdueAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports